enum AIVoice {
  lucie = "YxrwjAKoUKULGd0g8K9Y",
  sarah = "b6nVfb3l2zshrLZTvqbs",
  audia = "lvQdCgwZfBuOzxyV5pxu",
  emilie = "d3AXX0BlgJHYFCuH9X88",
  koraly = "gidGFDFyCSnGFnZ9hK7l",
  marine = "6FXyooAOTqUK8m2HWm32",
  chloe = "uyCFY7D8n0oaM5Smchqu",
}

export const aiVoiceAsString = (aiVoice: AIVoice): string => {
  switch (aiVoice) {
    case AIVoice.lucie:
      return "Lucie";
    case AIVoice.sarah:
      return "Sarah";
    case AIVoice.audia:
      return "Audia";
    case AIVoice.emilie:
      return "Émilie";
    case AIVoice.koraly:
      return "Koraly";
    case AIVoice.marine:
      return "Marine";
    case AIVoice.chloe:
      return "Chloé";
    default:
      return "";
  }
};

export default AIVoice;
